module.exports = __webpack_public_path__ + "img/asymmetry-left.4d188c7c.svg";